class CartNotification extends HTMLElement {
  constructor() {
    super();

    this.notification = document.getElementById('cart-notification');
    this.header = document.querySelector('sticky-header');
    this.onBodyClick = this.handleBodyClick.bind(this);

    // On garde les handlers "close" par sécurité, mais ça ne s’ouvrira jamais
    if (this.notification) {
      this.notification.addEventListener('keyup', (evt) => evt.code === 'Escape' && this.close());
    }

    this.querySelectorAll('button[type="button"]').forEach((closeButton) =>
      closeButton.addEventListener('click', this.close.bind(this))
    );
  }

  /**
   * IMPORTANT :
   * On ne veut PAS afficher la cart notification.
   * Donc open() ne fait rien, et on force même la notif à rester fermée.
   */
  open() {
    this.forceClosed();
    return;
  }

  close() {
    this.forceClosed();
    document.body.removeEventListener('click', this.onBodyClick);
    if (typeof removeTrapFocus === 'function') removeTrapFocus(this.activeElement);
  }

  /**
   * On garde le rendu des sections pour que :
   * - le compteur (cart-icon-bubble) se mette à jour
   * - les autres sections éventuelles restent cohérentes
   *
   * Mais on n’ouvre jamais la notif.
   */
  renderContents(parsedState) {
    this.cartItemKey = parsedState.key;

    this.getSectionsToRender().forEach((section) => {
      const container = document.getElementById(section.id);
      const sectionHtml = parsedState.sections?.[section.id];

      if (!container || !sectionHtml) return;

      container.innerHTML = this.getSectionInnerHTML(sectionHtml, section.selector);
    });

    if (this.header) this.header.reveal();

    // Ne jamais ouvrir
    this.forceClosed();
  }

  /**
   * Tu peux garder cart-notification-product / button si tu veux,
   * mais si tu t’en fous totalement, tu peux aussi les enlever.
   * LE PLUS IMPORTANT ICI : cart-icon-bubble.
   */
  getSectionsToRender() {
    return [
      {
        id: 'cart-notification-product',
        selector: `[id="cart-notification-product-${this.cartItemKey}"]`,
      },
      {
        id: 'cart-notification-button',
      },
      {
        id: 'cart-icon-bubble',
      },
    ];
  }

  getSectionInnerHTML(html, selector = '.shopify-section') {
    const doc = new DOMParser().parseFromString(html, 'text/html');
    const node = doc.querySelector(selector);
    return node ? node.innerHTML : '';
  }

  handleBodyClick(evt) {
    // Même si on n’ouvre pas, on garde le guard au cas où
    const target = evt.target;
    if (this.notification && target !== this.notification && !target.closest('cart-notification')) {
      const disclosure = target.closest('details-disclosure, header-menu');
      this.activeElement = disclosure ? disclosure.querySelector('summary') : null;
      this.close();
    }
  }

  setActiveElement(element) {
    this.activeElement = element;
  }

  forceClosed() {
    if (!this.notification) return;
    this.notification.classList.remove('animate', 'active');
    // si Dawn a un attribut open/aria, on nettoie aussi
    this.notification.removeAttribute('open');
    this.notification.setAttribute('aria-hidden', 'true');
  }
}

customElements.define('cart-notification', CartNotification);